import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import * as R from "ramda";
import Api from "../../../../Services/Api";
import { mapToObjectDDL } from "../../../common/mapper";

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      variantOptions: [],
      warnaOptions: [],
    };
  }

  async componentDidMount() {
    let apiList = [this.handleCallApi("variant")];
    if (!R.isNil(this.getDataValue("variantCode", null))) {
      apiList.push(this.handleCallApi("warna", this.props.state.filterData.variantCode.value));
    }
    const responses = await Promise.all(apiList);
    if (responses[0] && !R.isEmpty(responses[0])) {
      this.setState((prevValue) => ({
        ...prevValue,
        variantOptions: responses[0].map((v) => mapToObjectDDL(v.kodeVariant, v.kodeVariant)),
      }));
    }
    if (responses[1] && !R.isEmpty(responses[1])) {
      this.setState((prevValue) => ({
        ...prevValue,
        warnaOptions: responses[1].map((w) => mapToObjectDDL(w.namaWarnaKomersil, w.id)),
      }));
    }
  }

  handleCallApi = async (name, value) => {
    let api = Api.create("NAGAMAS_MASTER_DATA");
    let response;
    try {
      if (R.equals(name, "variant")) {
        response = await api.getAllVariant();
      } else {
        response = await api.getAllWarnaByParam({
          paramFilters: {
            kodeVariant: value,
          },
        });
      }

      if (response.ok) {
        return response.data.data;
      }
    } catch (error) {
      // TODO
    }

    return [];
  };

  handleVarianChange = async (name, value) => {
    this.handleValueChange("idWarna", null);
    this.handleValueChange(name, value);
    if (value) {
      const data = await this.handleCallApi("warna", value.value);
      this.setState((prevValue) => ({
        ...prevValue,
        warnaOptions: data.map((w) => mapToObjectDDL(w.namaWarnaKomersil, w.id)),
      }));
    }
  };

  handleDateChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleValueChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleClearFilter = () => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {},
    }));
  };

  getDataValue(fieldName, fallbackValue = "") {
    return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
      ? this.props.state.filterData[fieldName]
      : fallbackValue;
  }

  render() {
    return (
      <SimpleModal
        title="Filter"
        visible={this.props.state.filterVisible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
            <FlexView column vAlignContent="center">
              <div className="txt-site txt-11 txt-main txt-bold">
                <h4>Periode:</h4>
              </div>
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <SimpleDate
                  id="select_date_startDateDelivery"
                  name="startDateDelivery"
                  nextdate
                  date={this.getDataValue("startDateDelivery", null)}
                  maxDate={this.getDataValue("endDateDelivery", null)}
                  onChange={(value) => this.handleDateChange("startDateDelivery", value)}
                />
                <span className="margin-bottom-20px">To</span>
                <SimpleDate
                  id="select_date_endDateDelivery"
                  name="endDateDelivery"
                  nextdate
                  date={this.getDataValue("endDateDelivery", null)}
                  onChange={(value) => this.handleDateChange("endDateDelivery", value)}
                />
              </FlexView>
              <div style={{ width: "max-content" }}>
                <SimpleDate
                  id="select_date_salesInvoiceDate"
                  name="salesInvoiceDate"
                  label="Tanggal FJ"
                  nextdate
                  date={this.getDataValue("salesInvoiceDate", null)}
                  onChange={(value) => this.handleDateChange("salesInvoiceDate", value)}
                />
              </div>
              <SimpleInput
                id="input_text_salesInvoiceNumber"
                name="salesInvoiceNumber"
                label="Nomor FJ"
                value={this.getDataValue("salesInvoiceNumber")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <SimpleInput
                id="input_text_customerName"
                name="customerName"
                label="Nama Pembeli"
                value={this.getDataValue("customerName")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <SimpleInput
                id="input_text_customerStnkName"
                name="customerStnkName"
                label="Nama STNK"
                value={this.getDataValue("customerStnkName")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <SimpleDDL
                id="select_options_variantCode"
                box="search"
                name="variantCode"
                label="Kode Varian"
                isClearable
                options={this.state.variantOptions}
                value={this.getDataValue("variantCode")}
                onChange={(value, { name }) => this.handleVarianChange(name, value)}
              />
              <SimpleInput
                id="input_text_namaVariant"
                name="namaVariant"
                label="Nama Varian"
                value={this.getDataValue("namaVariant")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <SimpleDDL
                id="select_options_idWarna"
                box="search"
                name="idWarna"
                label="Warna"
                isClearable
                readOnly={R.isNil(this.getDataValue("variantCode", null))}
                options={this.state.warnaOptions}
                value={this.getDataValue("idWarna")}
                onChange={(value, { name }) => this.handleValueChange(name, value)}
              />
              <SimpleInput
                id="input_text_namaWarna"
                name="namaWarna"
                label="Nama Warna"
                value={this.getDataValue("namaWarna")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <FlexView hAlignContent="right" style={{ gap: "10px" }}>
                <SimpleButton type="button" secondary onClick={this.handleClearFilter}>
                  Clear
                </SimpleButton>
                <SimpleButton onClick={this.props.onSubmit}>Terapkan</SimpleButton>
              </FlexView>
            </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default Filter;
